import { StandardEvents } from '@shopify/events';

/**
 * Keeps the specifications table in step with the selected variant.
 *
 * Horizon only morphs the variant picker on a product page; price, SKU and the
 * gallery each update themselves through their own components. The spec table
 * carries variant-scoped data (the style code differs per colourway), so it
 * needs the same treatment: take the freshly server-rendered block out of the
 * fetched HTML and swap this element for it.
 */
class MeharSpecs extends HTMLElement {
  #target = null;

  connectedCallback() {
    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"]');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#target = null;
  }

  #handleProductSelect = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const next = detail.html.querySelector('mehar-specs');
        if (next && next.innerHTML !== this.innerHTML) this.replaceWith(next);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[mehar-specs] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('mehar-specs')) {
  customElements.define('mehar-specs', MeharSpecs);
}
